import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // ハッシュがある場合のスクロール処理
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleSectionClick = (e: React.MouseEvent<HTMLAnchorElement>, section: string) => {
    e.preventDefault();
    if (isHomePage) {
      const element = document.querySelector(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/${section}`);
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="text-lg font-medium mb-4">RepliGo</h3>
            <p className="text-gray-400">
              Google口コミ管理を自動化し、顧客満足度向上をサポートするAIソリューション
            </p>
          </div>
          
          <div>
            <h4 className="text-md font-medium mb-4">製品</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#features" 
                  onClick={(e) => handleSectionClick(e, '#features')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  機能
                </a>
              </li>
              <li>
                <a 
                  href="#testimonials" 
                  onClick={(e) => handleSectionClick(e, '#testimonials')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  お客様の声
                </a>
              </li>
              <li>
                <a 
                  href="#pricing" 
                  onClick={(e) => handleSectionClick(e, '#pricing')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  料金
                </a>
              </li>
              <li>
                <a 
                  href="#faq" 
                  onClick={(e) => handleSectionClick(e, '#faq')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  よくある質問
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-md font-medium mb-4">会社情報</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  利用規約
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-gray-400 hover:text-white transition-colors">
                  特定商取引法に基づく表記
                </Link>
              </li>
              <li>
                <a 
                  href="#contact" 
                  onClick={(e) => handleSectionClick(e, '#contact')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} ForceAI. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a href="mailto:yasuda_riku@forceai.jp" className="text-gray-400 hover:text-white transition-colors text-sm">
                yasuda_riku@forceai.jp
              </a>
              <a 
                href="#pricing" 
                onClick={(e) => handleSectionClick(e, '#pricing')}
                className="text-blue-400 hover:text-blue-300 transition-colors text-sm font-medium"
              >
                今すぐ始める
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;